import Scene01_OpeningHold from "./Scene01_OpeningHold";
import Scene02_QuizQuestion from "./Scene02_QuizQuestion";
import Scene03_TwoPlatforms from "./Scene03_TwoPlatforms";
import Scene04_FourHundredBillion from "./Scene04_FourHundredBillion";
import Scene05_TwelveTrillion from "./Scene05_TwelveTrillion";
import Scene07_VideoDominates from "./Scene07_VideoDominates";
import Scene08_AndYet from "./Scene08_AndYet";
import SceneQ1SoFar from "./SceneQ1SoFar";
import Scene09_CoreStack from "./Scene09_CoreStack";
import Scene10_WebsiteShowcase from "./Scene10_WebsiteShowcase";
import Scene11_PackageTable from "./Scene11_PackageTable";
import Scene13_TourIntro from "./Scene13_TourIntro";
import Scene14_HowItWorks from "./Scene14_HowItWorks";
import Scene15_ProductDemos from "./Scene15_ProductDemos";
import Scene16_TradeoffGone from "./Scene16_TradeoffGone";
import Scene17_Previously from "./Scene17_Previously";
import Scene18_VideoSystemDemo from "./Scene18_VideoSystemDemo";
import Scene19_Now from "./Scene19_Now";
import Scene20_OldVsYourWorld from "./Scene20_OldVsYourWorld";
import Scene21_AutomatedEditing from "./Scene21_AutomatedEditing";
import Scene22_WhatThisMeans from "./Scene22_WhatThisMeans";
import SceneShowMeTheMoney from "./SceneShowMeTheMoney";
import Scene23_BaselineCurrent from "./Scene23_BaselineCurrent";
import Scene24_CurrentMaths from "./Scene24_CurrentMaths";
import SceneGuessAICost from "./SceneGuessAICost";
import Scene25_NewModel from "./Scene25_NewModel";
import Scene26_Saving97k from "./Scene26_Saving97k";
import Scene27_FiftyKVideos from "./Scene27_FiftyKVideos";
import Scene28_Saving240k from "./Scene28_Saving240k";
import SceneRevenueProjection from "./SceneRevenueProjection";
import Scene29_Foundation from "./Scene29_Foundation";
import Scene30_CommercialReality from "./Scene30_CommercialReality";
import Scene31_TheUnlock from "./Scene31_TheUnlock";
import Scene32_OnePropertyBecomes from "./Scene32_OnePropertyBecomes";
import Scene33_LeadsMeTo from "./Scene33_LeadsMeTo";
import SceneSevenDays from "./SceneSevenDays";
import SceneSocialWeekDemo from "./SceneSocialWeekDemo";
import Scene34_ProposalFrame from "./Scene34_ProposalFrame";
import Scene35_QuizTime from "./Scene35_QuizTime";
import Scene36_CostToday from "./Scene36_CostToday";
import Scene37_ChannelsDying from "./Scene37_ChannelsDying";
import Scene38_RoughMaths from "./Scene38_RoughMaths";
import Scene39_FiveThousandClients from "./Scene39_FiveThousandClients";
import Scene40_TenPercent from "./Scene40_TenPercent";
import Scene41_TwoHundredK from "./Scene41_TwoHundredK";
import Scene42_TwoPointFourMillion from "./Scene42_TwoPointFourMillion";
import Scene43_TwentyPercent from "./Scene43_TwentyPercent";
import Scene45_NotAGimmick from "./Scene45_NotAGimmick";
import Scene48_BuiltFromContent from "./Scene48_BuiltFromContent";
import Scene47_DontGetReplaced from "./Scene47_DontGetReplaced";
import Scene49_WhyCastle from "./Scene49_WhyCastle";
import Scene50_TheCastle from "./Scene50_TheCastle";
import Scene51_TheKnights from "./Scene51_TheKnights";
import Scene52_TheMoat from "./Scene52_TheMoat";
import Scene53_HardToCompete from "./Scene53_HardToCompete";
import Scene54_FutureHero from "./Scene54_FutureHero";
import Scene55_VideoCritical from "./Scene55_VideoCritical";
import Scene56_PhotographersSafe from "./Scene56_PhotographersSafe";
import Scene58_ConnectedSuite from "./Scene58_ConnectedSuite";
import Scene59_Accelerating from "./Scene59_Accelerating";
import Scene60_iPhone22 from "./Scene60_iPhone22";
import Scene62_BuildForIt from "./Scene62_BuildForIt";
import Scene63_HousesAlwaysSell from "./Scene63_HousesAlwaysSell";
import Scene64_WhereWeWin from "./Scene64_WhereWeWin";
import Scene68_DeployAndScale from "./Scene68_DeployAndScale";

/**
 * Scene registry — order is presentation order.
 * Speaker notes for each scene live in `notes.js`, keyed by `id`.
 *
 * SECTION 1 · OPENING SPEECH + QUICK QUIZ        (scenes 1-8)
 * SECTION 2 · WHAT WE'VE BUILT (CORE STACK)      (scenes 9-12)
 * SECTION 3 · PRESENTOUR + NARRATOUR             (scenes 13-15)
 * SECTION 4 · VIDEO CREATION                     (scenes 16-22)
 * SECTION 5 · VIDEO COMMERCIALS · SAVINGS         (scenes 23-29)
 * SECTION 5b · COMMERCIAL REALITY + LEADS-IN      (scenes 30-33)
 * SECTION 6 · ONE MORE THING — SOCIAL WEEK        (scenes 34-48)
 * SECTION 7 · CASTLE METAPHOR — WHY SOCIAL WEEK   (scenes 49-53)
 * SECTION 8 · THE FUTURE + CLOSE                  (scenes 54-68)
 *   · Future hero · video critical               (54-55)
 *   · Reassure: photographers safe · AI point    (56-57)
 *   · Concept → connected suite                  (58)
 *   · Future vision: accelerating · iPhone 22 ·  (59-62)
 *   · Anchor: houses always sell · win · ahead   (63-65)
 *   · Personal: I'm here · one quarter · deploy  (66-68)
 */
export const scenes = [
  // ── SECTION 1 ─────────────────────────────────────────────────────────
  {
    id: "opening-hold",
    title: "Opening Hold",
    subtitle: "Floating product logos · speaker delivers opening",
    component: Scene01_OpeningHold,
  },
  {
    id: "quiz-question",
    title: "Quick Quiz",
    subtitle: "Calm hero",
    component: Scene02_QuizQuestion,
    props: { stage: 0 },
  },
  {
    id: "quiz-question-q",
    title: "Quick Quiz · Question",
    subtitle: "How many videos are watched online every day?",
    component: Scene02_QuizQuestion,
    props: { stage: 1 },
  },
  {
    id: "two-platforms",
    title: "First Reveal",
    subtitle: "Instagram + YouTube Shorts",
    component: Scene03_TwoPlatforms,
  },
  {
    id: "400-billion",
    title: "400 B per day",
    subtitle: "Together — daily",
    component: Scene04_FourHundredBillion,
  },
  {
    id: "12-trillion",
    title: "12 T per month",
    subtitle: "Stretch the timeline",
    component: Scene05_TwelveTrillion,
    props: { stage: 0 },
  },
  {
    id: "144-trillion",
    title: "144 T per year",
    subtitle: "Zoom out to the annual figure",
    component: Scene05_TwelveTrillion,
    props: { stage: 1 },
  },
  {
    id: "video-dominates",
    title: "Video Dominates",
    subtitle: "Video isn't growing — it's dominating",
    component: Scene07_VideoDominates,
  },
  {
    id: "and-yet",
    title: "And Yet…",
    subtitle: "In property — barely scratching the surface",
    component: Scene08_AndYet,
  },
  {
    id: "q1-so-far",
    title: "Q1 So Far",
    subtitle: "Where we are · big bold opener for Section 2",
    component: SceneQ1SoFar,
  },
  {
    id: "connected-suite",
    title: "The Journey",
    subtitle: "Concept → fully connected AI suite · animated timeline",
    component: Scene58_ConnectedSuite,
  },

  // ── SECTION 2 · CORE STACK ───────────────────────────────────────────
  {
    id: "core-stack",
    title: "Core Stack",
    subtitle: "Social Go + Social Pro · already live",
    component: Scene09_CoreStack,
  },
  {
    id: "website-showcase",
    title: "On the Website",
    subtitle: "Inset preview · click to Packages",
    component: Scene10_WebsiteShowcase,
  },
  {
    id: "package-table",
    title: "Packages Table",
    subtitle: "Social Go vs Social Pro · base table",
    component: Scene11_PackageTable,
    props: { stage: 0 },
  },
  {
    id: "package-table-new",
    title: "Packages Table · Two New Products",
    subtitle: "PresenTour + NarraTour rows drop in",
    component: Scene11_PackageTable,
    props: { stage: 1 },
  },

  // ── SECTION 3 · PRESENTOUR + NARRATOUR ───────────────────────────────

  // ── SECTION 3 · PRESENTOUR + NARRATOUR ───────────────────────────────
  {
    id: "tour-intro",
    title: "PresenTour + NarraTour",
    subtitle: "Tour scripts and updates · in seconds",
    component: Scene13_TourIntro,
  },
  {
    id: "how-it-works",
    title: "How does it work?",
    subtitle: "Script Builders · Tours + Property Updates",
    component: Scene14_HowItWorks,
  },
  {
    id: "product-demos",
    title: "Product Demos",
    subtitle: "Consistent, on-brand scripts · in seconds",
    component: Scene15_ProductDemos,
  },

  // ── SECTION 4 · VIDEO CREATION ───────────────────────────────────────
  {
    id: "previously",
    title: "Why Short-form Matters",
    subtitle: "Cost + editing time · why agents post less",
    component: Scene17_Previously,
  },
  {
    id: "tradeoff-gone",
    title: "Video Editing",
    subtitle: "Speed · Quality · Efficiency · all at once",
    component: Scene16_TradeoffGone,
  },
  {
    id: "automated-editing",
    title: "Automated Editing",
    subtitle: "AI beat mapping · music-driven cuts",
    component: Scene21_AutomatedEditing,
  },
  {
    id: "video-system-demo",
    title: "Video System Demo",
    subtitle: "Live demo · plug your video here",
    component: Scene18_VideoSystemDemo,
  },
  {
    id: "now",
    title: "Now",
    subtitle: "Behaviour flips · Post EVERYTHING. Everywhere.",
    component: Scene19_Now,
  },
  {
    id: "old-vs-your-world",
    title: "Old vs Your World",
    subtitle: "1 → 1 → 1 vs 1 → 10+ → multi-platform",
    component: Scene20_OldVsYourWorld,
  },
  {
    id: "what-this-means",
    title: "What This Means",
    subtitle: "RDs · Operations · IT · Delivery",
    component: Scene22_WhatThisMeans,
  },

  // ── SECTION 5 · VIDEO COMMERCIALS · COMMERCIAL IMPACT ────────────────
  {
    id: "show-me-the-money",
    title: "Show Me the Money!",
    subtitle: "Section 5 opener · time for some commercials",
    component: SceneShowMeTheMoney,
  },
  {
    id: "baseline-current",
    title: "Baseline · Today",
    subtitle: "20k videos · £45 rev · £5 cost · extremely competitive",
    component: Scene23_BaselineCurrent,
  },
  {
    id: "current-maths",
    title: "Current Maths",
    subtitle: "20,000 × £5 = £100,000",
    component: Scene24_CurrentMaths,
  },
  {
    id: "guess-ai-cost",
    title: "Guess · AI Cost",
    subtitle: "What's the cost per edit using AI tools?",
    component: SceneGuessAICost,
    props: { stage: 0 },
  },
  {
    id: "new-model",
    title: "New Model",
    subtitle: "£0.15 per video · 20k = £3,000",
    component: Scene25_NewModel,
  },
  {
    id: "saving-97k",
    title: "Impact · £97k",
    subtitle: "Saved per year",
    component: Scene26_Saving97k,
  },
  {
    id: "fifty-k-videos",
    title: "Scale · 50k Videos",
    subtitle: "Where we're going · £250k vs £7.5k",
    component: Scene27_FiftyKVideos,
  },
  {
    id: "saving-240k",
    title: "Impact · £240k+",
    subtitle: "Saved annually at 50k volume",
    component: Scene28_Saving240k,
  },
  {
    id: "revenue-projection",
    title: "Revenue · 50k × £45 + Bolt-on",
    subtitle: "Annual revenue line · £2.625M",
    component: SceneRevenueProjection,
  },
  {
    id: "foundation",
    title: "Foundation",
    subtitle: "AI-stabilised, longer-form video next",
    component: Scene29_Foundation,
  },

  // ── SECTION 5b · COMMERCIAL REALITY + LEADS-IN ───────────────────────
  {
    id: "commercial-reality",
    title: "Commercial Reality",
    subtitle: "Cost ↓ · Volume ↑ · Turnaround ↓ · Value ↑",
    component: Scene30_CommercialReality,
  },
  {
    id: "the-unlock",
    title: "The Unlock",
    subtitle: "Mark · WMS · ready to onboard",
    component: Scene31_TheUnlock,
  },
  {
    id: "one-property-becomes",
    title: "One Property Becomes 5",
    subtitle: "Sneak Peek · Full Tour · Story Cuts · Local · Hook",
    component: Scene32_OnePropertyBecomes,
  },

  // ── SECTION 6 · ONE MORE THING · SOCIAL WEEK ─────────────────────────
  {
    id: "proposal-frame",
    title: "Proposal Frame",
    subtitle: "It becomes market control · ownership of local presence",
    component: Scene34_ProposalFrame,
  },
  {
    id: "quiz-time",
    title: "Quiz Time",
    subtitle: "Two questions · find the gap · find the product",
    component: Scene35_QuizTime,
  },
  {
    id: "cost-today",
    title: "Cost Today",
    subtitle: "£30k videographer · £30k SMM · what they actually get",
    component: Scene36_CostToday,
  },
  {
    id: "channels-dying",
    title: "Channels Dying",
    subtitle: "Six pain points · why local presence is broken",
    component: Scene37_ChannelsDying,
  },
  {
    id: "leads-me-to",
    title: "Which Leads Me To…",
    subtitle: "Calm bridge",
    component: Scene33_LeadsMeTo,
    props: { stage: 0 },
  },
  {
    id: "social-week-reveal",
    title: "Social Week · Reveal",
    subtitle: "Dramatic Social Week unveil",
    component: Scene33_LeadsMeTo,
    props: { stage: 1 },
  },
  {
    id: "seven-days",
    title: "7 days of social",
    subtitle: "One press of a button · the elevator pitch",
    component: SceneSevenDays,
  },
  {
    id: "social-week-demo",
    title: "Social Week · Live Demo",
    subtitle: "The tool · screenshot in gold",
    component: SceneSocialWeekDemo,
  },
  {
    id: "rough-maths",
    title: "Rough Maths",
    subtitle: "Let's size the prize · back-of-envelope",
    component: Scene38_RoughMaths,
  },
  {
    id: "5k-clients",
    title: "5,000 Clients",
    subtitle: "Step 1 · the base across the portfolio",
    component: Scene39_FiveThousandClients,
  },
  {
    id: "ten-percent",
    title: "10% Take-up",
    subtitle: "Step 2 · 500 branches · conservative uptake",
    component: Scene40_TenPercent,
  },
  {
    id: "200k-monthly",
    title: "£200k / month",
    subtitle: "Step 3 · £400 × 500 = £200k/m",
    component: Scene41_TwoHundredK,
  },
  {
    id: "2-4-million",
    title: "£2.4M / year",
    subtitle: "The hero number · subscription only",
    component: Scene42_TwoPointFourMillion,
  },
  {
    id: "twenty-percent",
    title: "20% Uptake · £4–5M",
    subtitle: "Push the lever · annually",
    component: Scene43_TwentyPercent,
  },
  {
    id: "not-a-gimmick",
    title: "Not a Gimmick",
    subtitle: "A £3–5M arm · built from content we already capture",
    component: Scene45_NotAGimmick,
  },
  {
    id: "built-from-content",
    title: "Built From Content",
    subtitle: "Re-anchor · entirely from content we already have",
    component: Scene48_BuiltFromContent,
  },

  // ── SECTION 7 · CASTLE METAPHOR · WHY SOCIAL WEEK ────────────────────
  {
    id: "why-castle",
    title: "So Why Social Week?",
    subtitle: "The metaphor",
    component: Scene49_WhyCastle,
  },
  {
    id: "the-castle",
    title: "The Castle",
    subtitle: "Core services · photos · floorplans · video",
    component: Scene50_TheCastle,
  },
  {
    id: "the-knights",
    title: "Archers & Knights",
    subtitle: "Social Go + Social Pro · attack + expansion",
    component: Scene51_TheKnights,
  },
  {
    id: "the-moat",
    title: "The Moat",
    subtitle: "Social Week · retention + protection",
    component: Scene52_TheMoat,
  },
  {
    id: "hard-to-compete",
    title: "Hard to Compete",
    subtitle: "Together · very hard to compete with",
    component: Scene53_HardToCompete,
  },
  {
    id: "dont-get-replaced",
    title: "We Don't Get Replaced",
    subtitle: "The lock · embedded · sticky · structural",
    component: Scene47_DontGetReplaced,
  },

  // ── SECTION 8 · THE FUTURE + CLOSE ───────────────────────────────────
  {
    id: "accelerating",
    title: "Accelerating",
    subtitle: "Section opener · the world is moving",
    component: Scene59_Accelerating,
  },
  {
    id: "future-hero",
    title: "What does the future look like?",
    subtitle: "AR / glasses / property in the post-phone era",
    component: Scene54_FutureHero,
  },
  {
    id: "iphone-22",
    title: "No iPhone 22",
    subtitle: "It moves on to something else entirely",
    component: Scene60_iPhone22,
  },
  {
    id: "video-critical-image",
    title: "AR Glasses · Image",
    subtitle: "Cinematic full-bleed image, no copy",
    component: Scene55_VideoCritical,
    props: { stage: 0 },
  },
  {
    id: "video-critical",
    title: "Why Video",
    subtitle: "Closest digital format to real-world experience",
    component: Scene55_VideoCritical,
    props: { stage: 1 },
  },
  {
    id: "photographers-safe",
    title: "Photographers Are Safe",
    subtitle: "Reassure · expectations will change",
    component: Scene56_PhotographersSafe,
  },
  {
    id: "build-for-it",
    title: "Build For It",
    subtitle: "We don't react · we build",
    component: Scene62_BuildForIt,
  },
  {
    id: "houses-always-sell",
    title: "What Doesn't Change",
    subtitle: "Houses · people · presentation",
    component: Scene63_HousesAlwaysSell,
  },
  {
    id: "where-we-win",
    title: "That's Where We Win",
    subtitle: "Gold climax · the win line",
    component: Scene64_WhereWeWin,
  },
  {
    id: "deploy-and-scale",
    title: "Deploy. And Scale.",
    subtitle: "The final line · SOCIAL WEEK fully revealed",
    component: Scene68_DeployAndScale,
  },
];

export default scenes;
